(() => {
  'use strict';
  const routeRoot=window.Shopify?.routes?.root||'/';
  const storeRoot=new URL(routeRoot,location.origin);
  // Cart actions must stay on this storefront, including its active locale.
  if(storeRoot.origin!==location.origin)return;
  if(!storeRoot.pathname.endsWith('/'))storeRoot.pathname+='/';
  const cartUrl=new URL('cart',storeRoot).href;
  const addUrl=new URL('cart/add.js',storeRoot).href;
  function cartConfig(container){
    try{return JSON.parse(container.querySelector('[data-production-cart]').textContent);}
    catch{return null;}
  }
  function variantId(value){
    const id=String(value??'');
    if(!/^[1-9]\d{0,19}$/.test(id))throw new Error('This product is not ready to purchase. Please refresh the page or contact us.');
    return id;
  }
  function availableVariant(config,value){
    const id=variantId(value);
    const variant=config?.variants?.find(item=>String(item.id)===id);
    if(!variant)throw new Error('This option is not ready to purchase. Please refresh the page or contact us.');
    if(variant.available===false)throw new Error('This option is currently sold out. Please choose another option or contact us.');
    return id;
  }
  function cartAction(container,button,feedback){
    let pending=false;
    const label=button.textContent;
    feedback.setAttribute('role','status');
    feedback.setAttribute('aria-live','polite');
    function error(message){
      feedback.replaceChildren(document.createTextNode(message+' '));
      const link=document.createElement('a');
      link.href=cartUrl;link.textContent='View cart';
      feedback.append(link);
    }
    return {
      get pending(){return pending;},
      error,
      async submit(items){
        if(pending)return;
        pending=true;button.disabled=true;button.setAttribute('aria-busy','true');
        button.textContent='Adding…';feedback.textContent='Adding to your cart…';
        try{
          const response=await fetch(addUrl,{
            method:'POST',credentials:'same-origin',
            headers:{'Content-Type':'application/json','Accept':'application/json'},
            body:JSON.stringify({items})
          });
          let body;try{body=await response.json();}catch{}
          if(!response.ok||body?.status>=400){
            const description=typeof body?.description==='string'?body.description:
              typeof body?.message==='string'?body.message:'The item could not be added to your cart.';
            throw new Error(description+' Check your cart before trying again.');
          }
          // A malformed success response is ambiguous; never retry automatically.
          if(!Array.isArray(body?.items)||items.some(item=>!body.items.some(added=>String(added.variant_id??added.id)===String(item.id)))){
            throw new Error('We could not confirm every item was added. Check your cart before trying again.');
          }
          feedback.textContent='Added to your cart. Opening cart…';
          location.assign(cartUrl);
        }catch(problem){
          error(problem instanceof TypeError?'We could not confirm the cart update. Check your cart before trying again.':problem.message||'We could not update your cart. Check your cart before trying again.');
          pending=false;button.disabled=false;button.removeAttribute('aria-busy');button.textContent=label;
        }
      }
    };
  }
  function bindSubmission(button,handler){
    button.addEventListener('click',event=>{event.preventDefault();handler();});
    if(button.form)button.form.addEventListener('submit',event=>{event.preventDefault();handler();});
  }
  const root=document.querySelector('[data-etune-preview]');
  const accessportPage=document.querySelector('[data-accessport-product]');
  if(accessportPage&&!accessportPage.dataset.cartInitialized){
    accessportPage.dataset.cartInitialized='true';
    const config=cartConfig(accessportPage);
    const button=accessportPage.querySelector('[data-accessport-review]');
    const action=cartAction(accessportPage,button,accessportPage.querySelector('[data-accessport-feedback]'));
    try{
      if(config?.kind!=='accessport')throw new Error('This product is not ready to purchase. Please refresh the page or contact us.');
      availableVariant(config,config.variantId);button.disabled=false;
    }catch(problem){button.disabled=true;action.error(problem.message);}
    bindSubmission(button,()=>{
      if(action.pending)return;
      try{
        if(config?.kind!=='accessport')throw new Error('This product is not ready to purchase. Please refresh the page or contact us.');
        action.submit([{id:availableVariant(config,config.variantId),quantity:1}]);
      }catch(problem){action.error(problem.message);}
    });
  }
  if(!root||root.dataset.cartInitialized)return;
  root.dataset.cartInitialized='true';
  const production=cartConfig(root);
  const schema=JSON.parse(root.querySelector('[data-parts-schema]').textContent);
  const parts=schema.groups.flatMap(group=>group.parts);
  const fuel=root.querySelector('[data-fuel]');
  const review=root.querySelector('[data-config-review]');
  const feedback=root.querySelector('[data-preview-feedback]');
  const summary=root.querySelector('[data-preview-summary]');
  const components=[...root.querySelectorAll('[data-component]')];
  const shortcut=root.querySelector('[data-stock-shortcut]');
  const intercoolerType=root.querySelector('[data-intercooler-type]');
  const namedOptions=schema.mode==='named-options';
  const flexRules=schema.flexFuelRules;
  const flexPart=flexRules?parts.find(part=>part.key===flexRules.kitKey):null;
  const flexKit=flexPart?root.querySelector('[data-component="'+flexPart.key+'"]'):null;
  const pricingSummary=root.querySelector('[data-pricing-summary]');
  const addAccessport=root.querySelector('[data-add-accessport]');
  const cartButton=root.querySelector('[data-preview-cart]');
  const action=cartAction(root,cartButton,feedback);
  cartButton.disabled=false;
  [root.querySelector('[data-year]'),root.querySelector('[data-transmission]'),fuel,...components,intercoolerType].filter(Boolean).forEach(field=>field.required=true);
  if(addAccessport&&new URLSearchParams(location.search).get('accessport')==='add')addAccessport.checked=true;
  const currency=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',maximumFractionDigits:0});
  let previousPriceKey='';
  function applyVariantLink(){
    if(production?.kind!=='etune'||String(production.productId)!=='6865499357207')return;
    const values=new URL(location.href).searchParams.getAll('variant');
    if(values.length!==1||!/^[1-9]\d{0,19}$/.test(values[0]))return;
    if(!production.variants?.some(item=>String(item.id)===values[0]))return;
    const turboPart=parts.find(part=>part.key==='turbo');
    for(const group of ['Stock','Modified']){
      for(const [value,id] of Object.entries(production.variantMap?.[group]||{})){
        if(String(id)!==values[0]||![...fuel.options].some(option=>option.value===value))continue;
        fuel.value=value;
        root.querySelector('[data-component="turbo"]').value=group==='Stock'?turboPart.stockValue:turboPart.otherValue;
        return;
      }
    }
  }
  function syncVariantLink(){
    if(production?.kind!=='etune'||String(production.productId)!=='6865499357207')return;
    const turboPart=parts.find(part=>part.key==='turbo');
    const turbo=root.querySelector('[data-component="turbo"]').value;
    const group=turbo===turboPart.stockValue?'Stock':'Modified';
    const id=turboPart.choices.includes(turbo)?production.variantMap?.[group]?.[fuel.value]:null;
    const variant=production.variants?.find(item=>String(item.id)===String(id));
    const url=new URL(location.href);
    if(variant)url.searchParams.set('variant',String(variant.id));
    else url.searchParams.delete('variant');
    if(url.href!==location.href)window.history.replaceState(window.history.state,'',url.href);
  }
  function updateFuelRules(){
    if(!flexRules)return;
    const unavailable=flexRules.excludedTransmissions.includes(root.querySelector('[data-transmission]').value);
    const flexOption=[...fuel.options].find(option=>option.value===flexRules.fuelValue);
    flexOption.disabled=unavailable;
    if(unavailable&&fuel.value===flexRules.fuelValue)fuel.value='';
    const active=!unavailable&&fuel.value===flexRules.fuelValue;
    flexKit.disabled=!active;
    flexKit.required=active;
    [...flexKit.options].find(option=>option.value===flexPart.stockValue).disabled=active;
    if(!active)flexKit.value=flexPart.stockValue;
    else if(flexKit.value===flexPart.stockValue)flexKit.value='';
    flexKit.setCustomValidity(active&&!flexKit.value?'Choose a flex-fuel kit for Flex Fuel.':'');
    root.querySelector('[data-fuel-rule-note]').hidden=!unavailable;
    const fuelPriceNote=root.querySelector('[data-fuel-price-note]');
    if(fuelPriceNote)fuelPriceNote.hidden=unavailable;
    root.querySelector('[data-flex-kit-note]').textContent=active?'A kit is required for Flex Fuel.':'Available with Flex Fuel only.';
  }
  function stockEligible(select){
    return !select.disabled&&!(select===flexKit&&fuel.value===flexRules.fuelValue);
  }
  function summaryRow(label,value) {
    const row=document.createElement('div');
    const term=document.createElement('dt');
    const detail=document.createElement('dd');
    term.textContent=label;detail.textContent=value;
    row.append(term,detail);return row;
  }
  function updatePricing(){
    if(!pricingSummary)return;
    const charges=[{label:'E-tune',amount:schema.startingPrice}];
    if(fuel.value===flexRules.fuelValue)charges.push({label:'Flex Fuel',amount:schema.priceAddons.flexFuel});
    const turboPart=parts.find(part=>part.key==='turbo');
    const turbo=root.querySelector('[data-component="turbo"]').value;
    if(turbo&&turbo!==turboPart.stockValue&&turboPart.choices.includes(turbo))charges.push({label:'Non-stock turbo',amount:schema.priceAddons.nonStockTurbo});
    if(addAccessport?.checked)charges.push({label:'Accessport bundle discount',amount:-schema.accessportBundle.tuneDiscount});
    const priceKey=JSON.stringify(charges);
    if(priceKey===previousPriceKey)return;
    previousPriceKey=priceKey;
    pricingSummary.querySelector('[data-price-lines]').replaceChildren(...charges.map((charge,index)=>summaryRow(charge.label,(index&&charge.amount>0?'+':'')+currency.format(charge.amount))));
    const amount=charges.reduce((total,charge)=>total+charge.amount,0);
    const subtotal=pricingSummary.querySelector('[data-tune-subtotal]');
    subtotal.textContent=currency.format(amount);
    subtotal.dataset.amount=String(amount);
    const bundlePrice=pricingSummary.querySelector('[data-accessport-pricing]');
    if(bundlePrice){
      bundlePrice.hidden=!addAccessport.checked;
      const orderSubtotal=bundlePrice.querySelector('[data-order-subtotal]');
      const orderAmount=amount+schema.accessportBundle.product.price;
      orderSubtotal.textContent=currency.format(orderAmount);
      orderSubtotal.dataset.amount=String(orderAmount);
    }
  }
  function toggleDetails(container,visible,required=false){
    container.hidden=!visible;
    container.querySelectorAll('input,select').forEach(field=>{
      field.disabled=!visible;
      field.required=visible&&required;
      field.setCustomValidity(field.required&&!field.value.trim()?'Enter the details for your Other selection.':'');
    });
  }
  function render() {
    updateFuelRules();
    if(addAccessport){
      const serialField=root.querySelector('[data-ap-serial-field]');
      serialField.hidden=addAccessport.checked;
      serialField.querySelector('input').disabled=addAccessport.checked;
    }
    updatePricing();
    const rows=document.createElement('dl');
    const year=root.querySelector('[data-year]').value;
    const transmission=root.querySelector('[data-transmission]').value;
    rows.append(summaryRow('Vehicle',[year||'Year not selected',transmission||'Transmission not selected'].join(' · ')));
    const fuelDetail=root.querySelector('[data-fuel-detail]');
    const fuelNeedsDetails=namedOptions?fuel.value===schema.fuelOtherValue:/Ethanol Blend|Other fuel|Flex fuel|Dual Fuel/i.test(fuel.value);
    toggleDetails(fuelDetail,fuelNeedsDetails,namedOptions);
    fuel.setAttribute('aria-expanded',String(fuelNeedsDetails));
    const fuelNotes=fuelDetail.hidden?'':fuelDetail.querySelector('input').value.trim();
    rows.append(summaryRow('Fuel',[fuel.value||'Not selected',fuelNotes||(namedOptions&&fuelNeedsDetails?'Details needed':'')].filter(Boolean).join(' · ')));
    components.forEach(select=>{
      const key=select.dataset.component;
      const part=parts.find(part=>part.key===key);
      const info=root.querySelector('[data-detail-for="'+key+'"]');
      let text;
      if(Array.isArray(part.choices)){
        const other=Boolean(part.otherValue)&&select.value===part.otherValue;
        if(info){toggleDetails(info,other,true);select.setAttribute('aria-expanded',String(other));}
        const details=other?root.querySelector('[data-part-other="'+key+'"]').value.trim():'';
        text=other?[select.value,details||'Details needed'].join(' · '):select.value||'Not selected';
      }else{
        const modified=select.value==='modified';
        toggleDetails(info,modified);
        select.setAttribute('aria-expanded',String(modified));
        const brand=root.querySelector('[data-part-brand="'+key+'"]').value.trim();
        const model=root.querySelector('[data-part-model="'+key+'"]').value.trim();
        text=modified?['Modified',brand||'Brand needed',model].filter(Boolean).join(' · '):select.value==='stock'?(part.stockLabel||'Stock'):'Not selected';
      }
      rows.append(summaryRow(part.label,text));
      if(key==='intercooler'&&intercoolerType)rows.append(summaryRow(schema.intercoolerType.label,intercoolerType.value||'Not selected'));
    });
    if(addAccessport)rows.append(summaryRow('Accessport',addAccessport.checked?'Add COBB Accessport · '+schema.accessportBundle.product.sku:'Use my own Accessport'));
    const serial=addAccessport?.checked?'':root.querySelector('#etune-ap-serial').value.trim();
    if(serial)rows.append(summaryRow('Accessport serial number',serial));
    const notes=root.querySelector('#etune-notes').value.trim();
    if(notes) rows.append(summaryRow('Other details',notes));
    summary.replaceChildren(rows);
    const count=components.filter(select=>select.value).length;
    root.querySelector('[data-completion-count]').textContent=count+' of '+parts.length+' parts selected';
    shortcut.disabled=!components.some(select=>!select.value&&stockEligible(select));
    syncVariantLink();
    if(!action.pending)feedback.textContent='';
  }
  root.querySelectorAll('input,select,textarea').forEach(field=>field.addEventListener('input',render));
  root.querySelectorAll('select,input[type="checkbox"]').forEach(field=>field.addEventListener('change',render));
  shortcut.addEventListener('click',()=>{components.filter(select=>!select.value&&stockEligible(select)).forEach(select=>{select.value=parts.find(part=>part.key===select.dataset.component).stockValue||'stock';});render();});
  function configurationProperties(){
    const properties={
      'Model Year':root.querySelector('[data-year]').value,
      'Vehicle':'Subaru WRX',
      'Transmission Type':root.querySelector('[data-transmission]').value,
      'Fuel':fuel.value
    };
    if(fuel.value===schema.fuelOtherValue)properties['Other fuel details']=root.querySelector('[data-fuel-notes]').value.trim();
    components.forEach(select=>{
      const part=parts.find(part=>part.key===select.dataset.component);
      properties[part.label]=select.value;
      if(part.otherValue&&select.value===part.otherValue)properties['Other '+part.label.toLowerCase()+' details']=root.querySelector('[data-part-other="'+part.key+'"]').value.trim();
    });
    if(intercoolerType)properties['Intercooler Type']=intercoolerType.value;
    properties['Accessport']=addAccessport?.checked?'Add COBB Accessport · '+schema.accessportBundle.product.sku:'Use my own Accessport';
    const serial=root.querySelector('#etune-ap-serial');
    if(!serial.disabled&&serial.value.trim())properties['AP Serial Number']=serial.value.trim();
    const notes=root.querySelector('#etune-notes').value.trim();
    if(notes)properties['Other modifications & tuning goals']=notes;
    return properties;
  }
  bindSubmission(cartButton,()=>{
    if(action.pending)return;
    render();
    review.open=true;
    review.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'center'});
    const missing=components.filter(select=>!select.value&&select!==flexKit).length;
    const missingBrands=components.filter(select=>select.value==='modified'&&!root.querySelector('[data-part-brand="'+select.dataset.component+'"]').value.trim()).length;
    const reminders=[];
    if(!root.querySelector('[data-year]').value)reminders.push('select a year');
    if(!root.querySelector('[data-transmission]').value)reminders.push('select a transmission');
    if(!fuel.value)reminders.push('select a fuel');
    if(missing)reminders.push((namedOptions?'select an option':'choose stock or modified')+' for '+missing+' remaining '+(missing===1?'part':'parts'));
    if(missingBrands)reminders.push('add '+missingBrands+' missing '+(missingBrands===1?'brand':'brands'));
    if(namedOptions){
      if(flexKit&&fuel.value===flexRules.fuelValue&&!flexKit.value)reminders.push('select a flex-fuel kit');
      if(fuel.value===schema.fuelOtherValue&&!root.querySelector('[data-fuel-notes]').value.trim())reminders.push('add details for Other fuel');
      components.forEach(select=>{
        const part=parts.find(part=>part.key===select.dataset.component);
        if(part.otherValue&&select.value===part.otherValue&&!root.querySelector('[data-part-other="'+part.key+'"]').value.trim())reminders.push('add Other details for '+part.label);
      });
      if(intercoolerType&&!intercoolerType.value)reminders.push('select an intercooler type');
    }
    const invalid=[...root.querySelectorAll('input,select,textarea')].find(field=>!field.disabled&&!field.checkValidity());
    if(reminders.length||invalid){
      feedback.textContent=reminders.length?'To complete your setup, '+reminders.join('; ')+'.':'Please check the highlighted field before adding your tune.';
      if(invalid){invalid.focus();invalid.reportValidity();}
      return;
    }
    try{
      if(production?.kind!=='etune'||String(production.productId)!=='6865499357207')throw new Error('This tune is not ready to purchase. Please refresh the page or contact us.');
      const turbo=root.querySelector('[data-component="turbo"]').value;
      const group=turbo===parts.find(part=>part.key==='turbo').stockValue?'Stock':'Modified';
      const id=availableVariant(production,production.variantMap?.[group]?.[fuel.value]);
      const items=[{id,quantity:1,properties:configurationProperties()}];
      if(addAccessport?.checked){
        if(production.accessportAvailable===false)throw new Error('The Accessport is currently sold out. Uncheck Add an Accessport to purchase only your tune.');
        items.push({id:variantId(production.accessportVariantId),quantity:1});
      }
      action.submit(items);
    }catch(problem){action.error(problem.message);}
  });
  const dialog=root.querySelector('dialog');
  root.querySelector('[data-preview-image]').addEventListener('click',event=>{event.preventDefault();dialog.showModal();});
  root.querySelector('[data-close-image]').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
  applyVariantLink();
  render();
})();

